export default __webpack_public_path__ + "static/media/medical.8c68ae7d.png";